import { atom } from 'jotai';
import { SingleWorkflowState } from '~/atoms/schemas/workflowSchemas';

const initialState: SingleWorkflowState = {
  workflow: null,
  currentAgentEvent: null,
  agentEvents: [],
  isLoading: false,
  error: null,
};

export const singleWorkflowAtom = () => {
  return atom<SingleWorkflowState>(initialState);
};

export const atomCache = new Map<
  string,
  ReturnType<typeof atom<SingleWorkflowState>>
>();

export const getOrCreateWorkflowAtom = (workflowId: string) => {
  if (!atomCache.has(workflowId)) {
    atomCache.set(workflowId, singleWorkflowAtom());
  }
  const atom = atomCache.get(workflowId);
  if (!atom) {
    // This should never happen due to the check above, but this makes TypeScript happy
    const newAtom = singleWorkflowAtom();
    atomCache.set(workflowId, newAtom);
    return newAtom;
  }
  return atom;
};
